import React, { useEffect, useState } from 'react'
import { usePagination } from '../../../../../hooks/usePagination';
import { fetchItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import Pagination from '../../../../../components/Pagination';
interface UiVideo {
    id?: number;
    titre?: string;
    description?: string;
    urlYoutube?: string;
    createdAt?: string;
    updatedAt?: string;
}
export default function Videos() {

    // declaration de variables
    const [listData, setDataList] = useState<UiVideo[]>([]);
    const [formData, setFormData] = useState<Partial<UiVideo>>({});
    const [isEditing, setIsEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(4);
    const [totalPages, setTotalPages] = useState(1);
    //fin declaration



    // declaration de la pagination
    const { paginationRange, isCurrentPage, isFirstPage, isLastPage } = usePagination({
        currentPage,
        totalPages,
    });

    // chargement de la table
    const loadlistData = async () => {
        setLoading(true);
        try {
            const res = await fetchItems<UiVideo>('/fetch_video_data', {
                q: search,
                page: currentPage,
                limit,
            });
            setDataList(res.data);
            setTotalPages(res.totalPages);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = "Nos vidéos - Ouragan Academy";
        loadlistData();
    }, [search, currentPage, limit]);
    return (
        <section className="py-5" id="videos">

            {/* HEADER */}
            <div className="text-center mb-5">
                <h2 className="fw-bold display-10">
                    Nos <span className="text-primary">Vidéos Officielles</span>
                </h2>
                <p className="lead text-muted col-lg-12 mx-auto">
                    Plongez dans l’univers d’Ouragan Academy à travers nos reportages, entraînements,
                    témoignages et moments forts du terrain.
                </p>
            </div>

            {/* SEARCH BAR */}
            <div className="row justify-content-center mb-4">
                <div className="col-lg-12">
                    <div className="input-group shadow-sm rounded-pill overflow-hidden">
                        <input
                            type="text"
                            className="form-control border-0 py-3 px-4"
                            placeholder="Rechercher une vidéo..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                        <button
                            className="btn btn-primary px-4"
                            onClick={() => loadlistData()}
                        >
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="container">

                <div className="row g-4">

                    {/* LOADER OR ERROR */}
                    {listData.length === 0 ? (
                        <LoaderAndError
                            loading={loading}
                            error={error}
                            onClearError={() => setError(null)}
                        />
                    ) : (
                        listData.map((item) => (
                            <div className="col-md-6 col-lg-6" key={item.id}>
                                <div className="project-card shadow-sm rounded-4 border-0 h-100 overflow-hidden bg-white dark:bg-gray-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 p-4">

                                    {/* VIDEO FRAME */}
                                    <div className="ratio ratio-16x9 bg-light">
                                        <iframe
                                            src={item.urlYoutube}
                                            title={item.titre}
                                            allowFullScreen
                                            className="w-100 h-100"
                                            style={{ border: 0 }}
                                        />
                                    </div>

                                    {/* CONTENT */}
                                    <div className="card-body">
                                        <h5 className="fw-bold mb-2 text-dark">
                                            {item.titre}
                                        </h5>
                                       
                                    </div>

                                </div>
                            </div>
                        ))
                    )}

                </div>

                {/* PAGINATION */}
                <div className="text-center mt-5">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        paginationRange={paginationRange}
                        isCurrentPage={isCurrentPage}
                        isFirstPage={isFirstPage}
                        isLastPage={isLastPage}
                        onPageChange={setCurrentPage}
                        textCounter={true}
                    />
                </div>

            </div>
        </section>


    )
}
